export default __webpack_public_path__ + "static/media/homepage_slider2.53d37e61.webp";